<div class="clients-page-wrapper page-shell">
  <mat-toolbar class="header">
    <span>
      {{ "client.addNew" | translate }}: {{ (clients$ | async)?.length || 0 }}
    </span>
  </mat-toolbar>

  <div class="content-wrapper">
    <div class="form-section">
      <h3 class="section-title">{{ "client.actions" | translate }}</h3>

      <div class="manual-report-buttons">
        <button
          *ngIf="auth.isSuperAdmin && isDevelopmentEnvironment"
          mat-stroked-button
          type="button"
          (click)="runExpiredTrialCron()"
        >
          <mat-icon>schedule</mat-icon>
          <span>{{ "client.runExpiredTrialCron" | translate }}</span>
        </button>

        <button
          *ngIf="auth.isSuperAdmin"
          mat-stroked-button
          type="button"
          (click)="openSuperAdminDialog()"
        >
          <mat-icon>admin_panel_settings</mat-icon>
          <span>{{ "client.manageSuperAdmins" | translate }}</span>
        </button>

        <button mat-stroked-button type="button" (click)="generateReport()">
          <mat-icon>cloud_download</mat-icon>
          <span>{{ "client.downloadReport" | translate }}</span>
        </button>

        <button
          mat-stroked-button
          type="button"
          (click)="downloadAnalyticsReport()"
          [disabled]="isDownloadingAnalytics"
        >
          <mat-icon *ngIf="!isDownloadingAnalytics">analytics</mat-icon>
          <mat-spinner
            diameter="20"
            *ngIf="isDownloadingAnalytics"
            class="dbc1-spinner dbc1-spinner--sm"
          ></mat-spinner>
          <span *ngIf="!isDownloadingAnalytics">{{
            "client.downloadAnalyticsReport" | translate
          }}</span>
        </button>

        <a mat-stroked-button target="_blank" [href]="spreadsheetUrl">
          <mat-icon>launch</mat-icon>
          <span>{{ "client.openSpreadsheet" | translate }}</span>
        </a>

        <a
          mat-stroked-button
          target="_blank"
          [href]="billingInvoiceSpreadsheetUrl"
        >
          <mat-icon>receipt_long</mat-icon>
          <span>{{ "client.openBillingInvoice" | translate }}</span>
        </a>
      </div>
    </div>

    <div class="form-section">
      <h3 class="section-title">{{ "client.addNew" | translate }}</h3>
      <form [formGroup]="form" class="add-client-form" (ngSubmit)="add()">
        <mat-form-field appearance="outline">
          <mat-label>{{ "client.domain" | translate }}</mat-label>
          <input matInput formControlName="domain" type="text" [errorStateMatcher]="errorStateMatcher" />
          <mat-error *ngIf="form.hasError('required', ['domain'])">
            {{ "fieldRequired" | translate }}
          </mat-error>
          <mat-error *ngIf="form.hasError('httpExists', ['domain'])">
            {{ "domainWithoutHttp" | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ "client.googleAdminEmail" | translate }}</mat-label>
          <input matInput formControlName="googleAdminEmail" type="text" [errorStateMatcher]="errorStateMatcher" />
          <mat-error *ngIf="form.hasError('required', ['googleAdminEmail'])">
            {{ "fieldRequired" | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ "editClient.subscription" | translate }}</mat-label>
          <mat-select formControlName="planId" [errorStateMatcher]="errorStateMatcher">
            <mat-option *ngFor="let plan of planOptions" [value]="plan">
              {{ plan }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.hasError('required', ['planId'])">
            {{ "fieldRequired" | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          *ngIf="form.get('planId')?.value === 'free'"
        >
          <mat-label>{{ "client.trialFinishDate" | translate }}</mat-label>
          <input
            matInput
            [matDatepicker]="picker"
            formControlName="trialFinishDate"
            [errorStateMatcher]="errorStateMatcher"
          />
          <mat-hint>YYYY-MM-DD</mat-hint>
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="form.hasError('required', ['trialFinishDate'])">
            {{ "fieldRequired" | translate }}
          </mat-error>
          <mat-error *ngIf="form.hasError('dateInvalid', ['trialFinishDate'])">
            {{ "futureDateInvalid" | translate }}
          </mat-error>
        </mat-form-field>

        <div class="checkbox-wrapper">
          <mat-checkbox formControlName="isIncludedDemoContent" color="primary">
            {{ "client.includeDemoContent" | translate }}
          </mat-checkbox>
        </div>

        <button
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="saving"
          [class.loading-button]="saving"
        >
          <mat-spinner
            diameter="20"
            *ngIf="saving"
            class="dbc1-spinner dbc1-spinner--sm"
          ></mat-spinner>
          <mat-icon *ngIf="!saving">add</mat-icon>
          <span *ngIf="!saving">{{ "add" | translate }}</span>
        </button>
      </form>
    </div>

    <app-client-table
      [data]="clients$"
      [actionsTemplate]="actions"
      (reloadRequested)="loadData()"
    ></app-client-table>
  </div>

  <ng-template #actions let-client="client">
    <div class="table-actions">
      <a
        class="action-btn"
        [routerLink]="['/admin/client', client.clientId]"
        data-table-no-row-nav
      >
        <mat-icon>edit</mat-icon>
        {{ "edit" | translate }}
      </a>
      <button
        type="button"
        class="action-btn action-btn--danger"
        (click)="remove(client); $event.stopPropagation()"
        [disabled]="
          (removing && removingDomain === client.domain) ||
          !canBeDeleted(client)
        "
        [matTooltip]="getDeleteTooltip(client)"
      >
        <mat-spinner
          *ngIf="removing && removingDomain === client.domain"
          diameter="14"
          class="dbc1-spinner dbc1-spinner--sm"
        ></mat-spinner>
        <mat-icon *ngIf="!(removing && removingDomain === client.domain)">delete</mat-icon>
        {{ "delete" | translate }}
      </button>
    </div>
  </ng-template>
</div>
